import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { DepositorDetailsService } from 'src/app/services/depositor-details.service';
import { DirectorMasterService } from 'src/app/services/director-master.service';
import { environment } from 'src/environments/environment';
import { CustomValidation } from 'src/app/helpers/customValidation';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { AlertComponent } from '../../alert/alert.component';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-depositor-details',
  templateUrl: './depositor-details.component.html',
  styleUrls: ['./depositor-details.component.css']
})
export class DepositorDetailsComponent implements OnInit {
  isSearchDivVisible = false;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  public environmentSettings: any; 
  public isVisible: boolean = false;
  dtOptions: DataTables.Settings = {};
  rows: FormArray;
  addDepositForm: FormGroup;
  addList: any = [];
  showminorYesClick: boolean;
  showTable: boolean;
  dtOptionDeposit: DataTables.Settings = {};
  dtTriggerDeposit: Subject<any> = new Subject();
  depositDetailList: any[];
  depositor: any = [];
  editRemarkId: any;
  depositorList: any = [];
  id: string = '';
  amount: '';
  editForm: FormGroup;
  regulatoryForm: FormGroup;
  depositorForm: FormGroup;
  restrictTabflag: boolean;
  editRegulatroy: any;
  depositorAddButton: boolean;
  regulatoryAddButton: boolean;
  deleteDepositId: any;
  dateOfResolutionPassed: { month: number; day: number; year: number; };
  dateOfCircularReg: { month: number; day: number; year: number; };
  dateOfFilingResolution: { month: number; day: number; year: number; };
  dateOfAppointment: { month: number; day: number; year: number; };
  dateOfExecutingTrustDeed: { month: number; day: number; year: number; };
  dateOfBirthOfMinor: { month: number; day: number; year: number; };
  dueDateForReview: { month: number; day: number; year: number; };
  dateFrom: { month: number; day: number; year: number; };
  dateOfDeposit: { month: number; day: number; year: number; };
  dateTo: { month: number; day: number; year: number; };
  dueDateOfPaymentOfInterest: { month: number; day: number; year: number; };
  dateOfPaymentOfIntrest: { month: number; day: number; year: number; };
  dateOfDepositInsurance: { month: number; day: number; year: number; };
  countryList: any[];
  newFieldAttribute: any;
  newFieldArray: { id: number; title: string; }[];
  newField:any;
  depositdata:any;
  pipe:any;
  addDeposites = true;
  array:any;
  disabledOnClick: boolean;
  dateOfRepayable: any;
  dateOfDepositTo: any;
  futureToDate: NgbDateStruct;
  futureToDateTo: NgbDateStruct;
  response: boolean;

  constructor(private activatedRoute: ActivatedRoute, private router: Router,private fb: FormBuilder,  private alert: AlertComponent,
      private commonFunction: CommonFunction,
    private route: ActivatedRoute, private depositorDetailsService: DepositorDetailsService, private customValidation: CustomValidation,
    private directorMasterService: DirectorMasterService, private formBuilder: FormBuilder) {

  }


  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.depositorAddButton = false;
        this.regulatoryAddButton = true;
        this.editRegulatroy = params['particularId'];
        this.getDepositorsDetails(this.editRegulatroy);
      } else {
        this.restrictTabflag = false;
        this.depositorAddButton = true;
        this.regulatoryAddButton = true;
      }
    })
    this.getAllNations();

    this.addDepositForm = this.formBuilder.group({
      newField: new FormArray([   
       
      ]),
    });
  
    this.newFieldArray = [];

    this.regulatoryForm = new FormGroup({
      dateOfResolution: new FormControl('', []),
      amountApproved: new FormControl('', [Validators.pattern("^[0-9,/-]*$"), Validators.maxLength(20)]),
      dateOfCircular: new FormControl('', []),
      dateOfFiling: new FormControl('', []),
      credit: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 +-]*$"), Validators.maxLength(7)]),
      nameOfCredit: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$"), Validators.maxLength(50)]),
      dueDate: new FormControl('', []),
      aggregate: new FormControl('', [Validators.pattern("^[0-9 .%]*$"), Validators.maxLength(6)]),
      shortTermAggregate: new FormControl('', [Validators.pattern("^[0-9 .%]*$"), Validators.maxLength(6)]),
      dateOfAppoint: new FormControl('', []),
      nameAndAddress: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$"), Validators.maxLength(250)]),
      dateOfExecuting: new FormControl('', [])
    })

    this.depositorForm = new FormGroup({
      depositorRecipt: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9]*$"), Validators.maxLength(10), this.customValidation.noWhitespaceValidator]),
      depositorType: new FormControl('', [Validators.required]),
      nameOfDepositor: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9'.,& -]*$"), Validators.maxLength(20)]),
      holdersName: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& /-]*$"), Validators.maxLength(200)]),
      isMinor: new FormControl('', []),
      dateOfBirth: new FormControl('', []),
      guardian: new FormControl('', [Validators.pattern("^[a-zA-Z'.,& -]*$"), Validators.maxLength(50)]),
      address: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& /-]*$"), Validators.maxLength(250)]),
      regAddress: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& /-]*$"), Validators.maxLength(250)]),
      panNo: new FormControl('', [Validators.pattern("^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$")]),
      emailId: new FormControl('', [Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      nominee: new FormControl('', [Validators.pattern("^[a-zA-Z'.,& -]*$"), Validators.maxLength(500)]),
      identificationNo: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(12)]),
      CIN: new FormControl('', [Validators.maxLength(21), Validators.pattern("^[a-zA-Z0-9]*$")]),
      occupation: new FormControl('', [Validators.pattern("^[a-zA-Z0-9'.,& -]*$"), Validators.maxLength(20)]),
      nationality: new FormControl('', []),
      paymentOfIntrest: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 '.,& /-]*$"), Validators.maxLength(500)]),
      loanTaken: new FormControl('', []),
    })

    this.editForm = this.fb.group({
      'dateOfDeposit': [],
      'amount': [],
      'typeOfDeposit': [],
      'percentageOfDeposit': [],
      'natureOfDeposit': [],
      'exemptedDeposits':[],
      'months': [],
      'dateFrom': [],
      'dateTo': [],
      'depositRepayableData': [],
      'depositsPayableToDepositor': [],
      'rateOfInterest': [],
      'dueDateOfPaymentOfInterest': [],
      'dateOfPaymentOfIntrest': [],
      'dateOfDepositInsurance': [],
      'repaymentOfDeposits': [],
      'CHG7': []
    });

  
    this.environmentSettings = environment;


    this.dtOptionDeposit = {
      destroy: true,
      scrollX: true,
      scrollY: "210px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      columnDefs: [{ orderable: false, targets: [4] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: []
    };
   // this.getDepositDetailList();
    // }
  }
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }
  getDepositorsDetails(_id) {
    this.depositorDetailsService.getDepositor(_id).subscribe(res => {
      // depositors details
      var depositorDetails = res.data;
      this.depositorForm.controls.depositorRecipt.setValue(depositorDetails.depositorRecipt);
      this.depositorForm.controls.depositorType.setValue(depositorDetails.depositorType);
      this.depositorForm.controls.nameOfDepositor.setValue(depositorDetails.nameOfDepositor);
      this.depositorForm.controls.holdersName.setValue(depositorDetails.holdersName);
      this.depositorForm.controls.isMinor.setValue(depositorDetails.isMinor);
      this.depositorForm.controls.guardian.setValue(depositorDetails.guardian);
      this.depositorForm.controls.address.setValue(depositorDetails.address);
      this.depositorForm.controls.regAddress.setValue(depositorDetails.regAddress);
      this.depositorForm.controls.panNo.setValue(depositorDetails.panNo);
      this.depositorForm.controls.emailId.setValue(depositorDetails.emailId);
      this.depositorForm.controls.nominee.setValue(depositorDetails.nominee);
      this.depositorForm.controls.identificationNo.setValue(depositorDetails.identificationNo);
      this.depositorForm.controls.CIN.setValue(depositorDetails.CIN);
      this.depositorForm.controls.occupation.setValue(depositorDetails.occupation);
      this.depositorForm.controls.nationality.setValue(depositorDetails.nationality);
      this.depositorForm.controls.paymentOfIntrest.setValue(depositorDetails.paymentOfIntrest);
      this.depositorForm.controls.loanTaken.setValue(depositorDetails.loanTaken);

      if (depositorDetails.dateOfBirth != null) {
        let dt = new Date(this.setFormatDate(depositorDetails.dateOfBirth));
        this.dateOfBirthOfMinor = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (depositorDetails.isMinor) {
        this.showminorYesClick = true;
      }

      // regulatory details
      // check if regulatory exist
      var regulatoryData = res.data.regulatoryData
      if (regulatoryData) {
        this.regulatoryAddButton = false;
        this.regulatoryForm.controls.amountApproved.setValue(regulatoryData.amountApproved);
        this.regulatoryForm.controls.credit.setValue(regulatoryData.credit);
        this.regulatoryForm.controls.nameOfCredit.setValue(regulatoryData.nameOfCredit);
        this.regulatoryForm.controls.aggregate.setValue(regulatoryData.aggregate);
        this.regulatoryForm.controls.shortTermAggregate.setValue(regulatoryData.shortTermAggregate);
        this.regulatoryForm.controls.nameAndAddress.setValue(regulatoryData.nameAndAddress);

        if (regulatoryData.dateOfResolution != null) {
          let dt = new Date(this.setFormatDate(regulatoryData.dateOfResolution));
          this.dateOfResolutionPassed = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (regulatoryData.dateOfCircular != null) {
          let dt = new Date(this.setFormatDate(regulatoryData.dateOfCircular));
          this.dateOfCircularReg = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (regulatoryData.dateOfFiling != null) {
          let dt = new Date(this.setFormatDate(regulatoryData.dateOfFiling));
          this.dateOfFilingResolution = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (regulatoryData.dueDate != null) {
          let dt = new Date(this.setFormatDate(regulatoryData.dueDate));
          this.dueDateForReview = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (regulatoryData.dateOfAppoint != null) {
          let dt = new Date(this.setFormatDate(regulatoryData.dateOfAppoint));
          this.dateOfAppointment = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
        if (regulatoryData.dateOfExecuting != null) {
          let dt = new Date(this.setFormatDate(regulatoryData.dateOfExecuting));
          this.dateOfExecutingTrustDeed = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
        }
      }

      // if (res.data.depositDetails) {
      //   this.getDepositDetailList();
      // }
      else{
        this.regulatoryAddButton = true;
      }
      this.getDepositDetailList();

    }, err => {
      console.log("error ", err);
    })



  }

  getDepositors(_id): void {
    this.depositorDetailsService.getDepositor(_id).subscribe(response => {
      this.id = response.data.Info._id;
      this.editRemarkId = response.data.Info._id;
      this.editForm.setValue({
        dateOfDeposit: response.data.Info.dateOfDeposit,
        amount: response.data.Info.amount,
        typeOfDeposit: response.data.Info.typeOfDeposit, 
        percentageOfDeposit: response.data.Info.percentageOfDeposit,
        exemptedDeposits: response.data.Info.exemptedDeposits,
        natureOfDeposit: response.data.Info.natureOfDeposit,
        months: response.data.Info.months,
        dateFrom: response.data.Info.dateFrom,
        dateTo: response.data.Info.dateTo,
        depositRepayableData: response.data.Info.depositRepayableData,
        depositsPayableToDepositor: response.data.Info.depositsPayableToDepositor,
        rateOfInterest: response.data.Info.rateOfInterest,
        dueDateOfPaymentOfInterest: response.data.Info.dueDateOfPaymentOfInterest,
        dateOfPaymentOfIntrest: response.data.Info.dateOfPaymentOfIntrest,
        dateOfDepositInsurance: response.data.Info.dateOfDepositInsurance,
        repaymentOfDeposits: response.data.Info.repaymentOfDeposits,
        CHG7: response.data.Info.CHG7,
      });
      $("#hello").modal("toggle");
    })
  }

  editDepositDetail(id) {
    this.addDeposites = false;
    var data =  this.depositDetailList.filter(function(item) {
      return item.depositDetails._id == id;
    });
    this.depositdata = data[0].depositDetails;
    $("#addNewForm").modal('toggle');
   

    var formArray: FormArray = <FormArray>this.addDepositForm.controls.newField;
    var formArraySize = _.size(formArray.controls);

    formArray.push(this.initialiseNewFieldArray());
    var formGroup: FormGroup = <FormGroup>formArray.controls[formArraySize];

    
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);

    
    formGroup.controls.amount.setValue(this.depositdata.amount);
    formGroup.controls.typeOfDeposit.setValue(this.depositdata.typeOfDeposit);
    formGroup.controls.percentageOfDeposit.setValue(this.depositdata.percentageOfDeposit);
    formGroup.controls.exemptedDeposits.setValue(this.depositdata.exemptedDeposits);
    formGroup.controls.natureOfDeposit.setValue(this.depositdata.natureOfDeposit);
    formGroup.controls.months.setValue(this.depositdata.months);
    formGroup.controls.depositsPayableToDepositor.setValue(this.depositdata.depositsPayableToDepositor);
    formGroup.controls.rateOfInterest.setValue(this.depositdata.rateOfInterest);
    formGroup.controls.repaymentOfDeposits.setValue(this.depositdata.repaymentOfDeposits);
    formGroup.controls.CHG7.setValue(this.depositdata.CHG7);


    if (this.depositdata.dateOfDeposit != null) {
    
      let dt = new Date(this.setFormatDate(this.depositdata.dateOfDeposit));
      formGroup.controls.dateOfDeposit.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
     } 
    if (this.depositdata.dateFrom != null) {
    
      let dt = new Date(this.setFormatDate(this.depositdata.dateFrom));
      formGroup.controls.dateFrom.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
     }
    if (this.depositdata.dateTo != null) {
      
        let dt = new Date(this.setFormatDate(this.depositdata.dateTo));
        formGroup.controls.dateTo.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
     }
    if (this.depositdata.depositRepayableData != null) {
      
        let dt = new Date(this.setFormatDate(this.depositdata.depositRepayableData));
        formGroup.controls.depositRepayableData.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
     }
     if (this.depositdata.dateOfDepositInsurance != null) {
      
        let dt = new Date(this.setFormatDate(this.depositdata.dateOfDepositInsurance));
        formGroup.controls.dateOfDepositInsurance.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
     }
    if (this.depositdata.dueDateOfPaymentOfInterest != null) {
   
      let dt = new Date(this.setFormatDate(this.depositdata.dueDateOfPaymentOfInterest));
      formGroup.controls.dueDateOfPaymentOfInterest.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }
    if (this.depositdata.dateOfPaymentOfIntrest != null) {
     
        let dt = new Date(this.setFormatDate(this.depositdata.dateOfPaymentOfIntrest));
        formGroup.controls.dateOfPaymentOfIntrest.setValue( { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
    }

  }

  dateSet(date) {
  
    if (date != "" && date != null) {
      if(date.month != undefined && date.day != undefined && date.year != undefined){
        return date.month + "-" + date.day + "-" + date.year;
      }
         else return date;   
    }
    return null;
    }


 updateDepositDetail() {
  
  this.disabledOnClick = true;
  this.array = this.addDepositForm.controls.newField;
    var item = this.array.controls[0];
   
    var holddata = {
      _id: this.depositdata._id,
      dateOfDeposit: this.dateSet(item.controls.dateOfDeposit.value),
      amount: item.controls.amount.value,
      typeOfDeposit: this.dateSet(item.controls.typeOfDeposit.value),
      percentageOfDeposit:item.controls.percentageOfDeposit.value,
      exemptedDeposits: item.controls.exemptedDeposits.value,
      natureOfDeposit: item.controls.natureOfDeposit.value,
      months: item.controls.months.value,
      dateFrom: this.dateSet(item.controls.dateFrom.value),
      dateTo: this.dateSet(item.controls.dateTo.value),
      depositRepayableData: this.dateSet(item.controls.depositRepayableData.value),
      depositsPayableToDepositor: item.controls.depositsPayableToDepositor.value,
      rateOfInterest: item.controls.rateOfInterest.value,
    
      dueDateOfPaymentOfInterest: this.dateSet(item.controls.dueDateOfPaymentOfInterest.value),
      dateOfPaymentOfIntrest: this.dateSet(item.controls.dateOfPaymentOfIntrest.value),
      dateOfDepositInsurance: this.dateSet(item.controls.dateOfDepositInsurance.value),
      repaymentOfDeposits: item.controls.repaymentOfDeposits.value,
      CHG7: item.controls.CHG7.value,
  }

  var object = {
    particularId: this.editRegulatroy,
    id: this.depositdata._id,
    
    data:holddata
    };
    
    

    this.depositorDetailsService.updateDetailsOfDeposit(object).subscribe(response => {
      this.disabledOnClick = false;
     
      if (response.status == 0) {
        this.alert.success(response.message);
        this.getDepositDetailList();
    
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
        $("#depositorTable").DataTable().destroy();
     
      }
      this.resetFields();
    })
   this.addDeposites = true;
   $("#depositorTable").DataTable().destroy();
       $("#addNewForm .close").click();
   
   }

  onFormSubmit(data: NgForm, _id) {
    this.depositorDetailsService.update(this.editRemarkId, data)
      .subscribe(response => {
        this.getDepositDetailList();
        $("#hello").modal("toggle");
        
      }, (err) => {
        console.log(err);
      }
      );
  }

  getDepositDetailList() {
    this.depositDetailList = [];
    var Id =this.editRegulatroy;
   
    var searchParam =
    {
      "dateOfRepayable": null,
      "dateOfDepositTo": null,
      'isSearch': false,
    };
    // $("#depositorTable").DataTable().destroy();
    this.depositorDetailsService.getDepositDetails(Id,searchParam)
      .subscribe(depositList => {
       
        this.depositDetailList = depositList.data;
        this.dtTriggerDeposit.next();
      });
  }
  doAdvSearch() {
    this.response = true;
    var searchParam =
    {
      "dateOfRepayable":this.setDate(this.dateOfRepayable),
      "dateOfDepositTo":this.setDate(this.dateOfDepositTo),
      'isSearch': true,
    };
    this.depositDetailList = [];
    $("#depositorTable").DataTable().destroy();
    var Id =this.editRegulatroy;
    this.depositorDetailsService.getDepositDetails(Id,searchParam)
    .subscribe(depositList => {
      
      this.response = false;
      this.depositDetailList = depositList.data;
      this.dtTriggerDeposit.next();
    });
  }
  clearAdvSearch() {

    this.dateOfRepayable = undefined;
    this.dateOfDepositTo = undefined;
    $("#depositorTable").DataTable().destroy();
    this.getDepositDetailList();
  }
  onAddRow() {
    
    this.showTable = true

  }
  onRemoveRow(rowIndex: number) {
    this.rows.removeAt(rowIndex);

    this.showTable = false
  }
 
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + '-' + date.day + '-' + date.year;
    }
    return null;
  }
 
  submitted = false;
  onSubmit() { this.submitted = true; }


  minorYesClick() {
    this.showminorYesClick = true;
  }
  showminorNoClick() {
    this.showminorYesClick = false;
    this.depositorForm.controls.dateOfBirth.setValue(null);
    this.depositorForm.controls.guardian.setValue('');
  }

  saveRegulatoryDetails() {
    this.disabledOnClick = true;
    var regulatoryObject = {
      amountApproved: this.regulatoryForm.controls.amountApproved.value,
      dateOfResolution: this.setDate(this.regulatoryForm.controls.dateOfResolution.value),
      dateOfCircular: this.setDate(this.regulatoryForm.controls.dateOfCircular.value),
      dateOfFiling: this.setDate(this.regulatoryForm.controls.dateOfFiling.value),
      dueDate: this.setDate(this.regulatoryForm.controls.dueDate.value),
      dateOfAppoint: this.setDate(this.regulatoryForm.controls.dateOfAppoint.value),
      dateOfExecuting: this.setDate(this.regulatoryForm.controls.dateOfExecuting.value),
      credit: this.regulatoryForm.controls.credit.value,
      nameOfCredit: this.regulatoryForm.controls.nameOfCredit.value,
      aggregate: this.regulatoryForm.controls.aggregate.value,
      shortTermAggregate: this.regulatoryForm.controls.shortTermAggregate.value,
      nameAndAddress: this.regulatoryForm.controls.nameAndAddress.value,
      particularId: this.editRegulatroy
    }

    this.depositorDetailsService.regulatoryData(regulatoryObject).subscribe(response => {
      this.disabledOnClick = false;
      this.regulatoryAddButton = false;
      if (response.status == 0) {
        this.alert.success(response.message);
      } else {
        if(response.err_fields){
          this.alert.error(response.err_fields + ' fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }
      }
    })
  }

  saveDepositorData(checkFlag) {
       
    this.disabledOnClick = true;
    var depositorDataObject = {
      depositorRecipt: this.depositorForm.controls.depositorRecipt.value,
      dateOfBirth: this.setDate(this.depositorForm.controls.dateOfBirth.value),
      depositorType: this.depositorForm.controls.depositorType.value,
      nameOfDepositor: this.depositorForm.controls.nameOfDepositor.value,
      holdersName: this.depositorForm.controls.holdersName.value,
      panNo: this.depositorForm.controls.panNo.value,
      emailId: this.depositorForm.controls.emailId.value,
      isMinor: this.depositorForm.controls.isMinor.value,
      guardian: this.depositorForm.controls.guardian.value,
      address: this.depositorForm.controls.address.value,
      regAddress: this.depositorForm.controls.regAddress.value,
      CIN: this.depositorForm.controls.CIN.value,
      nominee: this.depositorForm.controls.nominee.value,
      identificationNo: this.depositorForm.controls.identificationNo.value,
      occupation: this.depositorForm.controls.occupation.value,
      nationality: this.depositorForm.controls.nationality.value,
      paymentOfIntrest: this.depositorForm.controls.paymentOfIntrest.value,
      loanTaken: this.depositorForm.controls.loanTaken.value,
    }

    if (checkFlag == 'add') {
      this.depositorDetailsService.depositorData(depositorDataObject).subscribe(response => {
        this.disabledOnClick = false;
        this.depositorList = response.depositorList;
        if (response.status == 0) {
          this.restrictTabflag = true;
          this.depositorAddButton = false;
          this.editRegulatroy = response.data._id;
          this.alert.success(response.message);
        } else {
          if(response.err_fields){
            this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
          }else{
            this.alert.error(response.message);
          }
        }
      })
    } else if (checkFlag == 'update') {
      
      this.depositorDetailsService.updateDepositorData(depositorDataObject, this.editRegulatroy).subscribe(res => {
        this.disabledOnClick = false;
        if (res.status == 0) {
          this.alert.success(res.message);
        } else {
          if(res.err_fields){
            this.alert.error( JSON.stringify(res.err_fields) + 'fields are required or invalid.');
          }else{
            this.alert.error(res.message);
          }
        }
      })

    }

  }
  depositorTypeChanged() {
    if (this.depositorForm.controls.depositorType.value == 'BodyCorporate') {
      
      this.depositorForm.controls.regAddress.setValidators([Validators.required]);
      this.depositorForm.controls.address.setValidators([]);
      this.depositorForm.controls.address.updateValueAndValidity();
      this.showminorYesClick = false;
    } else if (this.depositorForm.controls.depositorType.value == 'Individual') {
     
      this.depositorForm.controls.address.setValidators([Validators.required]);
      this.depositorForm.controls.regAddress.setValidators([]);
      this.depositorForm.controls.regAddress.updateValueAndValidity();
    
    }
  }

  depositorSetValue(){
      this.depositorForm.controls.address.setValue('');
      this.depositorForm.controls.isMinor.setValue(null);
      this.depositorForm.controls.nominee.setValue('');
      this.depositorForm.controls.identificationNo.setValue('');
      this.depositorForm.controls.dateOfBirth.setValue(null);
      this.depositorForm.controls.guardian.setValue('');
      this.depositorForm.controls.regAddress.setValue('');
      this.depositorForm.controls.CIN.setValue('');
    }

  confirmDelete(id) {
    this.deleteDepositId = id;
    $("#deleteConfirm").modal('toggle');
  }

  deleteDepositDetails() {
    this.depositorDetailsService.removeDepositDetails(this.editRegulatroy, this.deleteDepositId)
      .subscribe(response => {
        if (response.status == 0) {
          this.alert.success(response.message);
          $("#depositorTable").DataTable().destroy(); 
          $('#deleteConfirm').modal('toggle');
        } else {
          this.alert.error(response.message);
        }
        this.getDepositDetailList();
      });
  }

  getAllNations() {
    this.directorMasterService.getNations().subscribe((relativeUpdate:any) => {
      
      this.countryList = this.commonFunction.sortByKey(relativeUpdate.countryList, 'Country');
    });
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['depositorList']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  addNewFieldsModal() {
    this.addDeposites = true;
    $("#addNewForm").modal('toggle');
    this.addNewFields();
  }

  addNewFields() {
  
    var formArray: FormArray = <FormArray>this.addDepositForm.controls.newField;
   

    formArray.push(this.initialiseNewFieldArray());
   
    this.newFieldAttribute = { 'newFieldValue': '', 'defaultValue': '' };
    this.newFieldArray.push(this.newFieldAttribute);
  }

  
  initialiseNewFieldArray(): FormGroup {
    return this.formBuilder.group({
      dateOfDeposit: new FormControl(null, [Validators.required]),
      amount: new FormControl('', [Validators.required, Validators.pattern("^[0-9,/-]*$"), Validators.maxLength(20)]),
      typeOfDeposit: new FormControl('', [Validators.required]),
      percentageOfDeposit: new FormControl('', [Validators.pattern("^[0-9 .%]*$"), Validators.maxLength(6)]),
      exemptedDeposits: new FormControl('', []),
      natureOfDeposit: new FormControl('', []),
      months: new FormControl('', [Validators.required]),
      dateFrom: new FormControl(null, []),
      dateTo: new FormControl(null, []),
      depositRepayableData: new FormControl('', [Validators.required]),
      depositsPayableToDepositor: new FormControl('', [Validators.required, Validators.pattern("^[0-9 /,-]*$"), Validators.maxLength(20)]),
      rateOfInterest: new FormControl('', [Validators.required,Validators.pattern("^[0-9 .%]*$"), Validators.maxLength(6)]),
      dueDateOfPaymentOfInterest: new FormControl(null, [Validators.required]),
      dateOfPaymentOfIntrest: new FormControl(null, [Validators.required]),
      dateOfDepositInsurance: new FormControl(null, []),
      repaymentOfDeposits: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'-]*$"), Validators.maxLength(250)]),
      CHG7: new FormControl('', [Validators.maxLength(500)])
    })
  }

  removeField(index) {
   
    this.newFieldArray.splice(index, 1);
    var formArray = <FormArray>this.addDepositForm.controls.newField;
    formArray.removeAt(index)
  }

  addDepositDetail(){
    this.disabledOnClick = true;
    var depositesData = [];
    this.addDepositForm.controls.newField.value.forEach((item, index)=>{
     let updatedObject =[{
     
      dateOfDeposit:this.setDate(this.addDepositForm.controls.newField.value[index].dateOfDeposit),
      amount: this.addDepositForm.controls.newField.value[index].amount,
      typeOfDeposit: this.addDepositForm.controls.newField.value[index].typeOfDeposit,
      percentageOfDeposit: this.addDepositForm.controls.newField.value[index].percentageOfDeposit,
      exemptedDeposits: this.addDepositForm.controls.newField.value[index].exemptedDeposits,
      natureOfDeposit: this.addDepositForm.controls.newField.value[index].natureOfDeposit,
      months:this.addDepositForm.controls.newField.value[index].months,
      dateFrom:this.setDate(this.addDepositForm.controls.newField.value[index].dateFrom),
      dateTo:this.setDate(this.addDepositForm.controls.newField.value[index].dateTo),
      depositRepayableData:this.setDate(this.addDepositForm.controls.newField.value[index].depositRepayableData),
      depositsPayableToDepositor: this.addDepositForm.controls.newField.value[index].depositsPayableToDepositor,
      rateOfInterest: this.addDepositForm.controls.newField.value[index].rateOfInterest,
      dueDateOfPaymentOfInterest:this.setDate(this.addDepositForm.controls.newField.value[index].dueDateOfPaymentOfInterest),
      dateOfPaymentOfIntrest:this.setDate(this.addDepositForm.controls.newField.value[index].dateOfPaymentOfIntrest),
      dateOfDepositInsurance:this.setDate(this.addDepositForm.controls.newField.value[index].dateOfDepositInsurance),
      repaymentOfDeposits: this.addDepositForm.controls.newField.value[index].repaymentOfDeposits,
      CHG7: this.addDepositForm.controls.newField.value[index].CHG7,
    
    }]
   
  
   depositesData.push(updatedObject[0]);
    });
     var object = {
      particularId: this.editRegulatroy,
      data:depositesData
    };
  
    this.depositorDetailsService.addDepositsDetail(object).subscribe(response => {
 
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.success(response.message);
     
        this.getDepositDetailList();
         $("#depositorTable").DataTable().destroy();
         $("#addNewForm .close").click()
      
      } else {
        $("#depositorTable").DataTable().destroy();
        if(response.err_fields){
          this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }else{
          this.alert.error(response.message);
        }

        $("#addNewForm .close").click()
      }
     
      $("#depositorTable").DataTable().destroy();
     this.resetFields();
    
     
    })
    
  }

  resetFields(){
    var formArray: FormArray = <FormArray>this.addDepositForm.controls.newField;
    const index = _.size(formArray.controls);
    for(let i = index-1; i >= 0; i--) {
      this.newFieldArray.splice(i, 1);
      formArray = <FormArray>this.addDepositForm.controls.newField;
      formArray.removeAt(i)
      }
  }

  generateOutput() {
    var object = {
      id: this.editRegulatroy,
      fromDate: null,
      toDate: null,
      name: null
    }
    this.depositorDetailsService.generateDepositorDetailsDocument(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editRegulatroy);
          setTimeout(function () {
            self.downloadPdfDocument(self.editRegulatroy);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }

  downloadDocument(id) {
    this.depositorDetailsService.downloadDepositorDetailsFile(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.depositorDetailsService.downloadDepositorDetailsPdfFile(id, 'Single');
  }


}
